import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Menu, { MenuItem } from 'material-ui/Menu';
import { withStyles } from 'material-ui/styles';
import ArrowDropDown from 'material-ui-icons/ArrowDropDown';

import SvgIcon from 'material-ui/SvgIcon';
import Icon from 'material-ui/Icon';
import MobileMenu from './MobileMenu';

const CONFIG = require('../../../config.json');

const HomeIcon = props => (
  <SvgIcon {...props}>
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </SvgIcon>
);

const styles = theme => ({
  root: {
    display: 'flex',
  },
  popperClose: {
    pointerEvents: 'none',
  },
  icon: {
    cursor: 'pointer',
  },
  button: {
    fontSize: '1em',
    height: 40,
    float: 'left',
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  menuitem: {
    fontSize: '1em',
  },
  menuContent: {
    marginTop: 30,
    zIndex: 9999,
  },
});

class TopMenu extends React.PureComponent {
  state = {
    anchorEl: null,
  };

  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    onHomeClick: PropTypes.func.isRequired,
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClick1 = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose1 = (filter) => {
    this.setState({ anchorEl: null });
    if (filter) {
      const { handleFilterClick } = this.props;
      handleFilterClick(filter);
    }
  };

  handleClick2 = event => {
    this.setState({ anchorEl1: event.currentTarget });
  };

  handleClose2 = (filter) => {
    this.setState({ anchorEl1: null });
    if (filter) {
      const { handleFilterClick } = this.props;
      handleFilterClick(filter);
    }
  };

  handleClose = () => {
    if (this.state.anchorEl) {
      this.setState({ anchorEl: null });
    }
    if (this.state.anchorEl1) {
      this.setState({ anchorEl1: null });
    }
    if (this.state.anchorEl2) {
      this.setState({ anchorEl2: null });
    }
  }

  handleClick3 = event => {
    this.setState({ anchorEl2: event.currentTarget });
  };

  handleClose3 = (filter) => {
    this.setState({ anchorEl2: null });
    if (filter) {
      const { handleFilterClick } = this.props;
      handleFilterClick(filter);
    }
  };

  handleDownload = () => {
    location.href = CONFIG.fileURL;
  };

  render() {
    const { classes, onHomeClick } = this.props;
    const { anchorEl1, anchorEl, anchorEl2 } = this.state;
    const open = Boolean(anchorEl);
    const open1 = Boolean(anchorEl1);
    const open2 = Boolean(anchorEl2);
    return (
      <div onClick={() => this.handleClose()}>
        <div className="topmenu">
          <HomeIcon className="iconHover" style={{ float: 'left' }} onClick={() => onHomeClick()} />
          <Button className={classes.button} onClick={() => this.handleClose1('qatar-charity')}>
            Qatar Charity
          </Button>
          <Button
            className={classes.button}
            aria-owns={open ? 'menu-appbar' : null}
            aria-haspopup="true"
            onClick={this.handleClick1}
          >
            Qatar Charity in UK
            <ArrowDropDown className={classes.rightIcon} />
          </Button>
          <Menu
            className="menu-content"
            id="menu-appbar"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={open}
            anchorEl={anchorEl}
          >
            <MenuItem className="menu-item" onClick={() => this.handleClose1('qcuk')}>Overview</MenuItem>
            <MenuItem className="menu-item" onClick={() => this.handleClose1('qcuk+history')}>History</MenuItem>
            <MenuItem className="menu-item" onClick={() => this.handleClose1('qcuk+leadership')}>Leadership</MenuItem>
            <MenuItem className="menu-item" onClick={() => this.handleClose1('qcuk+funding')}>Funding</MenuItem>
          </Menu>
          <Button
            className={classes.button}
            aria-owns={open1 ? 'menu-appbar1' : null}
            aria-haspopup="true"
            onClick={this.handleClick2}
          >
            Emaan Trust
            <ArrowDropDown className={classes.rightIcon} />
          </Button>
          <Menu
            id="menu-appbar1"
            className="menu-content"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={open1}
            anchorEl={anchorEl1}
          >
            <MenuItem className="menu-item" onClick={() => this.handleClose2('sheffield+history')}>History</MenuItem>
            <MenuItem className="menu-item" onClick={() => this.handleClose2('sheffield+leadership')}>Leadership</MenuItem>
            <MenuItem className="menu-item" onClick={() => this.handleClose2('sheffield+funding')}>Funding</MenuItem>
          </Menu>
        </div>
        <div className="mobilemenu">
          <Icon
            className="iconHoverMobile"
            onClick={this.handleClick3}
          >
            menu
          </Icon>
          <MobileMenu isopen={open2} handleClose={(filter) => this.handleClose3(filter)} handleDownload={() => this.handleDownload()} />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(TopMenu);



// WEBPACK FOOTER //
// ./scripts/components/TopMenu.jsx